import * as React from "react";
import * as shortid from "shortid";
import * as Lodash from "lodash";
import ImgFrom from "react-image";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { masqueSource, target /* noImageUrl */ } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @name shortid
   * @infos "https://reactjs.org"
   */
  return (
    <div className="masque-tunnel">
      <ImgFrom
        src={target + "?nocache=" + shortid.generate()}
        loader={<div className="imageBrokenLoader" />}
        className="bg-image video-camera"
      />

      {!Lodash.isUndefined(masqueSource) &&
        Lodash.isArray(masqueSource) &&
        masqueSource.map((source: any) => (
          <ImgFrom
            key={shortid.generate()}
            src={source}
            className="masqueAll"
          />
        ))}
    </div>
  );
};

// initialisation des props
Component.defaultProps = {
  // masqueSource: [],
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  masqueSource?: any;
  target?: any;
  noImageUrl?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/masque/component.tsx